import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user: {},
        fromUrl: '',
        // Nuevo: Datos temporales del paciente durante el flujo de reserva
        temporaryPatient: null,
        // FEAT-2026-07-08-001: sesión efímera de reserva (30 min).
        // sessionStorage: sobrevive refresh, muere al cerrar la pestaña.
        bookingToken: sessionStorage.getItem('bookingToken') || '',
        bookingFlags: JSON.parse(sessionStorage.getItem('bookingFlags') || 'null')
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, { token, user }) {
            state.status = 'success'
            state.token = token
            state.user = user
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
            state.user = {}
        },
        setFromUrl(state, fromUrl) {
            state.fromUrl = fromUrl;
        },
        setUser(state, user) {
            state.user = user;
        },
        // Nuevas mutaciones para datos temporales del paciente
        SET_TEMPORARY_PATIENT(state, patientData) {
            state.temporaryPatient = patientData;
        },
        CLEAR_TEMPORARY_PATIENT(state) {
            state.temporaryPatient = null;
        },
        // FEAT-2026-07-08-001: sesión efímera de reserva
        SET_BOOKING_SESSION(state, { bookingToken, flags }) {
            state.bookingToken = bookingToken || '';
            state.bookingFlags = flags || null;
            if (bookingToken) {
                sessionStorage.setItem('bookingToken', bookingToken);
            } else {
                sessionStorage.removeItem('bookingToken');
            }
            if (flags) {
                sessionStorage.setItem('bookingFlags', JSON.stringify(flags));
            } else {
                sessionStorage.removeItem('bookingFlags');
            }
        },
        CLEAR_BOOKING_SESSION(state) {
            state.bookingToken = '';
            state.bookingFlags = null;
            sessionStorage.removeItem('bookingToken');
            sessionStorage.removeItem('bookingFlags');
        }
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: 'login', data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        const user = resp.data.user
                        localStorage.setItem('token', token)
                        // Add the following line:
                        //axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', { token, user })
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        register({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: 'register', data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        const user = resp.data.user
                        localStorage.setItem('token', token)
                        // Add the following line:
                        //axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', { token, user })
                        // El registro también emite un token de reserva para
                        // continuar la toma de hora sin fricción
                        if (resp.data.bookingToken) {
                            commit('SET_BOOKING_SESSION', {
                                bookingToken: resp.data.bookingToken,
                                flags: { requiresBirthDate: false, requiresAgreement: false }
                            })
                        }
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error', err)
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        // FEAT-2026-07-08-001: identificación por RUT → token efímero de reserva.
        // La respuesta del backend es mínima (flags), sin datos personales.
        identify({ commit }, rut) {
            return new Promise((resolve, reject) => {
                axios({ url: 'identify', data: { rut }, method: 'POST' })
                    .then(resp => {
                        if (resp.data.isRegistered) {
                            commit('SET_BOOKING_SESSION', {
                                bookingToken: resp.data.bookingToken,
                                flags: {
                                    requiresBirthDate: resp.data.requiresBirthDate,
                                    requiresAgreement: resp.data.requiresAgreement
                                }
                            })
                        } else {
                            commit('CLEAR_BOOKING_SESSION')
                        }
                        resolve(resp.data)
                    })
                    .catch(err => reject(err))
            })
        },
        setBookingFlags({ commit, state }, flags) {
            commit('SET_BOOKING_SESSION', { bookingToken: state.bookingToken, flags })
        },
        clearBookingSession({ commit }) {
            commit('CLEAR_BOOKING_SESSION')
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                localStorage.removeItem('token')
                commit('logout')
                //delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        saveFromUrl({ commit }, fromUrl) {
            commit('setFromUrl', fromUrl);
        },
        commitUser({ commit }, user) {
            commit('setUser', user);
        },
        // Nuevas acciones para manejar datos temporales del paciente
        setTemporaryPatient({ commit }, patientData) {
            commit('SET_TEMPORARY_PATIENT', patientData);
        },
        clearTemporaryPatient({ commit }) {
            commit('CLEAR_TEMPORARY_PATIENT');
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        getToken: state => state.token,
        getUser: state => state.user,
        getUserFullName: state => {
            return (state.user || {}).fullName
        },
        getFromUrl: state => state.fromUrl,
        // Nuevo getter para obtener datos temporales del paciente
        getTemporaryPatient: state => state.temporaryPatient,
        // FEAT-2026-07-08-001
        getBookingToken: state => state.bookingToken,
        getBookingFlags: state => state.bookingFlags,
        hasBookingSession: state => !!state.bookingToken
    }
})